import { Text } from "north.js";
import React, { Fragment } from "react";

import { Divider } from "src/shared/components";
import HardwareItemCard from "src/shared/components/Hardware/ItemCard";
import globalConstants from "src/theme/globalConstants";

import RequestActions from "./RequestActions";
import {
  RequestGroup as RequestGroupStyled,
  RequestHeader,
  RequestInfo,
  UserInfo,
} from "./styles";
import Timeline from "./Timeline";
import { TRequestGroupProps } from "./types";

const RequestGroupComponent: React.FC<TRequestGroupProps> = ({
  requestId,
  items,
  requestData,
  status,
  userType,
  onPrintLabel,
  onUpdateStatus,
  onRefresh,
  onReturnSuccess,
  isLoading = false,
  printerEndpoint,
  printingRequests,
  updatingRequests,
  selectedStatuses,
  onStatusChange,
}) => {
  return (
    <RequestGroupStyled>
      <RequestHeader>
        <RequestInfo>
          {userType === "organizer" && (
            <div>
              <Text type="h3">Request #{requestId}</Text>
              {requestData && (
                <UserInfo>
                  <Text
                    type="body2"
                    style={{
                      color: globalConstants?.color?.textSecondary as string,
                      fontWeight: 600,
                    }}
                  >
                    {requestData.user?.name || "Unknown user"}
                  </Text>
                  <Text
                    type="body2"
                    style={{
                      color: globalConstants?.color?.textSecondary as string,
                    }}
                  >
                    {requestData.user?.email || "No email"}
                  </Text>
                </UserInfo>
              )}
            </div>
          )}
          {userType === "hacker" && <Text type="h3">Request #{requestId}</Text>}
        </RequestInfo>
        <RequestActions
          requestId={requestId}
          requestData={requestData}
          status={status}
          userType={userType}
          onPrintLabel={onPrintLabel}
          onUpdateStatus={onUpdateStatus}
          onRefresh={onRefresh}
          onReturnSuccess={onReturnSuccess}
          isLoading={isLoading}
          printerEndpoint={printerEndpoint}
          printingRequests={printingRequests}
          updatingRequests={updatingRequests}
          selectedStatuses={selectedStatuses}
          onStatusChange={onStatusChange}
        />
      </RequestHeader>

      {/* Timeline Section */}
      {userType === "organizer" && requestData && (
        <Timeline requestData={requestData} />
      )}

      {items.map((item, index) => (
        <Fragment key={item.skuCode + item.requestId}>
          {index !== 0 && <Divider />}
          <HardwareItemCard
            {...item}
            showRemainingQuantity={false}
            description={userType === "hacker" ? "" : item.description}
          />
        </Fragment>
      ))}
    </RequestGroupStyled>
  );
};

export default RequestGroupComponent;
